import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    categories: {
      active: 'Your coverage',
      complete: 'Need more?',
      noCoverage: 'Insurances available',
    },
    description: 'All the insurances you need on a daily basis',
    title: 'Insurances',
  },
  fr: {
    categories: {
      active: 'Votre couverture',
      complete: 'Besoin de plus ?',
      noCoverage: 'Assurances disponibles',
    },
    description: 'Toutes les assurances qui vous protègent au quotidien',
    title: 'Assurances',
  },
} as const);

export default locales;
